import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from '../../../service/ajax.service';
import { UtilService } from '../../../service/util.service';
import { API } from '../../../../environments/environment';

interface Assessor {
  id: number;
  idusuario: number;
  idUsuarioEncript: string;
  nome: string;
  email: string;
  cpf: string;
  datacadastro: string;
  registro: string | null;
  ativo: boolean;
  observacoes: string | null;
  especialidades: string | null;
}

@Component({
  selector: 'app-visualizar-assessor',
  templateUrl: './visualizar-assessor.component.html',
  styleUrls: ['./visualizar-assessor.component.scss']
})
export class VisualizarAssessorComponent implements OnInit {

  assessores: Assessor[] = [];
  assessoresFiltrados: Assessor[] = [];


  // Filtros
  filtroNome: string = '';
  filtroCpf: string = '';
  filtroEmail: string = '';
  filtroStatus: string = '';

  statusOptions = [
    'Ativo',
    'Inativo'
  ];

  loading: boolean = false;
  errorMessage: string = '';

  constructor(
    private router: Router,
    private ajaxService: AjaxService,
    private util: UtilService
  ) { }

  ngOnInit(): void {
    this.carregarAssessores();
    this.aplicarFiltros();
  }

  carregarAssessores(): void {
    this.loading = true;
    this.errorMessage = '';
    
    const url = API + 'empresa/UsuarioFisioterapeuta/ConsultarUsuarios';
    
    this.util.showLoading();
    
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.util.closeLoading();
        this.loading = false;
        console.log('Resposta da API:', response);
        
        if (response && response.data && Array.isArray(response.data)) {
          // Filtrar apenas assessores válidos e converter para lowercase
          this.assessores = response.data
            .filter(usuario => usuario && typeof usuario === 'object')
            .map(usuario => this.util.converterParaLowercase(usuario))
            .map(usuario => ({
              id: usuario.id || 0,
              idusuario: usuario.idusuario || 0,
              idUsuarioEncript: usuario.idusuarioencript || '',
              nome: usuario.nome || '',
              email: usuario.email || '',
              cpf: usuario.cpf || '',
              datacadastro: usuario.datacadastro || '',
              registro: usuario.registro || null,
              ativo: usuario.ativo !== undefined ? usuario.ativo : false,
              observacoes: usuario.observacoes || null,
              especialidades: usuario.especialidades || null
            }));
          
          console.log('Assessores mapeados:', this.assessores);
        } else {
          console.log('Resposta inválida ou sem dados:', response);
          this.assessores = [];
        }
        
        this.assessoresFiltrados = [...this.assessores];
        this.aplicarFiltros();
      },
      error: (error) => {
        this.util.closeLoading();
        this.loading = false;
        console.error('Erro ao carregar assessores:', error);
        this.util.toasterShowError('Erro', 'Erro ao carregar lista de assessores');
        this.assessores = [];
        this.assessoresFiltrados = [];
        this.aplicarFiltros();
      }
    });
  }

  agendarAssessor(assessor: Assessor): void {
    console.log('Agendar assessor:', assessor);
    
    // Redirecionar para a tela de disponibilizar horários
    this.router.navigate(['/disponibilizar-horarios'], {
      queryParams: {
        assessorId: assessor.id,
        assessorNome: assessor.nome,
        assessorEmail: assessor.email,
        idUsuarioEncript: assessor.idUsuarioEncript
      }
    });
  }


  aplicarFiltros(): void {
    console.log('Aplicando filtros:', {
      filtroNome: this.filtroNome,
      filtroCpf: this.filtroCpf,
      filtroEmail: this.filtroEmail,
      filtroStatus: this.filtroStatus
    });

    this.assessoresFiltrados = this.assessores.filter(assessor => {
      // Filtrar registros vazios ou inválidos
      if (!assessor || !assessor.nome || assessor.nome.trim() === '') {
        return false;
      }

      const matchNome = !this.filtroNome ||
        (assessor.nome && assessor.nome.toLowerCase().includes(this.filtroNome.toLowerCase()));
      
      const matchCpf = !this.filtroCpf ||
        (assessor.cpf && assessor.cpf.toLowerCase().includes(this.filtroCpf.toLowerCase()));
      
      const matchEmail = !this.filtroEmail ||
        (assessor.email && assessor.email.toLowerCase().includes(this.filtroEmail.toLowerCase()));
      
      const matchStatus = !this.filtroStatus ||
        (this.filtroStatus === 'Ativo' && assessor.ativo) ||
        (this.filtroStatus === 'Inativo' && !assessor.ativo);

      const resultado = matchNome && matchCpf && matchEmail && matchStatus;
      
      if (this.filtroNome || this.filtroCpf || this.filtroEmail || this.filtroStatus) {
        console.log(`Assessor ${assessor.nome}:`, {
          matchNome,
          matchCpf,
          matchEmail,
          matchStatus,
          resultado
        });
      }

      return resultado;
    });

    console.log(`Filtros aplicados: ${this.assessoresFiltrados.length} de ${this.assessores.length} assessores`);
  }

  limparFiltros(): void {
    this.filtroNome = '';
    this.filtroCpf = '';
    this.filtroEmail = '';
    this.filtroStatus = '';
    this.aplicarFiltros();
  }



  getStatusClass(ativo: boolean): string {
    return ativo ? 'badge bg-success' : 'badge bg-secondary';
  }

  formatarData(data: string): string {
    if (!data || data.trim() === '') return '-';
    
    try {
      const dataObj = new Date(data);
      
      // Verificar se a data é válida
      if (isNaN(dataObj.getTime())) {
        return '-';
      }
      
      return dataObj.toLocaleDateString('pt-BR');
    } catch (error) {
      console.warn('Erro ao formatar data:', data, error);
      return '-';
    }
  }

  formatarCpf(cpf: string): string {
    if (!cpf || cpf.trim() === '') return '-';
    
    // Remove caracteres não numéricos
    const cpfLimpo = cpf.replace(/\D/g, '');
    
    // Verifica se tem 11 dígitos
    if (cpfLimpo.length !== 11) return cpf;
    
    return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
} 